export class LqdCarouselHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.reposition = liquidDebounce(this.reposition.bind(this), 150);
    this.resize = liquidDebounce(this.resize.bind(this), 150);

    this.initCarousel();
    this.initCustomAnimation();
    // this.setHeightCongtrol();

  }

  // getModel() {

  //   const modelCID = this.getModelCID();

  //   return elementorFrontend.config.elements.data[ modelCID ];

  // }

  // getSettingsModel() {

  //   let settings;
  //   const model = this.getModel();

  //   if ( this.isEdit && model ) {
  //     settings = model;
  //   } else {
  //     settings = this.$element.data( 'settings' ) || {};
  //   }

  //   return settings;

  // }

  getDefaultSettings() {
    return {
      flickityData: null,
      selectors: {
        carouselElement: '[data-lqd-flickity]',
        customAnimationElement: '[data-custom-animations]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $carouselElement: this.$element.find(selectors.carouselElement),
      $customAnimationElement: this.$element.find(selectors.customAnimationElement),
    }
  }

  initCarousel() {

    this.elements.$carouselElement.liquidCarousel({
      bypassCheck: true
    });

    this.setSettings('flickityData', this.elements.$carouselElement.data('plugin_liquidCarousel'));

  }

  // async setHeightCongtrol() {

  //   const pluginData = this.getSettings('flickityData');
  //   await pluginData.carouselInitPromise;

  //   const flickityData = pluginData.flickityData;

  //   if ( ! flickityData ) return;

  //   console.log(flickityData);

  //   const model = this.getModel();
  //   const {maxCellHeight} = flickityData;

  //   model.setExternalChange('carousel_height', maxCellHeight);

  // }

  initCustomAnimation() {

    this.elements.$customAnimationElement.liquidCustomAnimations();

  }

  onElementChange(propertyName) {

    switch (propertyName) {

      case 'columns':
      case 'cells_height':
      case 'carousel_item_spacing':
      case 'carousel_item_inner_padding':
      case 'carousel_item_inner_margin':
        this.resize();
    }

  }

  reposition() {

    const flickityData = this.getSettings('flickityData');

    if ( ! flickityData ) {
      return
    }

    flickityData.flickityData.reposition();

  }

  resize() {

    const flickityData = this.getSettings('flickityData');

    if ( ! flickityData ) {
      return
    }

    flickityData.flickityData.resize();

  }

  onDestroy() {

    this.handleRemoveNav();
    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleCarouselDestroy();
    this.handleCustomAnimationDestroy();

  }

  handleCarouselDestroy() {

    if ( ! this.elements.$carouselElement.length ) return;

    const carouselData = this.elements.$carouselElement.data('plugin_liquidCarousel');

    if ( carouselData ) {
      carouselData.destroy();
    }

  }

  handleCustomAnimationDestroy() {

    if ( ! this.elements.$customAnimationElement.length ) return;

    const customAnimationData = this.elements.$customAnimationElement.data('plugin_liquidCustomAnimations');

    if ( customAnimationData ) {
      customAnimationData.destroy();
    }

  }

  handleRemoveNav() {

    const flickityData = this.getSettings('flickityData');

    if ( ! flickityData ) return;

    if ( flickityData.carouselNavElement ) {
      jQuery(flickityData.carouselNavElement).remove()
    }

    if ( flickityData.carouselDotsElement ) {
      jQuery(flickityData.carouselDotsElement).remove()
    }

  }

}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdCarouselHandler, { $element } );
};